import { forkJoin } from 'rxjs';
import { VariablesService } from './../../../shared/services/variables/variables.service';
import { MatDialog } from '@angular/material/dialog';
import { DOCUMENT } from '@angular/common';
import { EventsService } from './../../../shared/services/events/events.service';
import { UtilService } from './../../../shared/services/util/util.service';
import { CampaignService } from './../../../shared/services/campaign/campaign.service';
import { ActivatedRoute, Router } from '@angular/router';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { Component, OnInit, Input, Inject, OnDestroy } from '@angular/core';
import { RELATIONSHIP } from './../../objects/relationship';
import { SacPurposeDialogComponent } from '../../../common/sac-purpose/components/sac-purpose-dialog/sac-purpose-dialog.component';
import { defaultIfEmpty, first } from 'rxjs/operators';
import { QUALIFICATION_LIST, OCCUPATION_LIST } from '../../objects/basic-info.model';
import { BrandSurveyData } from 'src/app/shared/models/brand-survey';
import { StartAFrUrls } from 'src/app/shared/models/start-fr-urls';

@Component({
  selector: 'app-basic',
  templateUrl: './basic.component.html',
  styleUrls: ['./basic.component.scss']
})
export class BasicComponent implements OnInit, OnDestroy {

  basicForm: FormGroup;
  amount_requested: FormControl;
  relation: FormControl;
  qualification: FormControl;
  occupation: FormControl;
  qualificationList = QUALIFICATION_LIST;
  occupationList = OCCUPATION_LIST;
  @Input() info;
  @Input() draft;
  relationship = RELATIONSHIP;
  type = 'personal';
  isLoading = false;
  campaignerPhone: FormControl;
  survey: FormControl;
  selectedSurvey;
  askCampaignerPhone = true;
  extn;
  brandSurveyData = BrandSurveyData;
  startAFrUrls = StartAFrUrls;
  surveyDataConfig = {};
  subs = [];

  constructor(
    private actRoute: ActivatedRoute,
    private campaignService: CampaignService,
    public util: UtilService,
    private events: EventsService,
    public dialog: MatDialog,
    private router: Router,
    private vars: VariablesService,
    @Inject(DOCUMENT) private document: any,
  ) {
    this.getDraft();
  }

  ngOnInit() {
    this.initForm();
    this.getPhoneExtn();
    this.actRoute.queryParams.pipe(first()).subscribe(
      (data) => {
        if (data.askPurpose === 'true') {
          setTimeout(() => {
            this.openChangePurpose();
          }, 0);
          this.router.navigate([], {
            queryParams: {
              askPurpose: null,
            },
            queryParamsHandling: 'merge'
          });
        }
        if (data.hospital === 'true') {
          this.surveyDataConfig = {
            disabled: true,
            selected: { 'value': 'Brochure / Banner in Hospital', 'label': 'Brochure / Banner in Hospital' }
          };
        }
      }
    );
  }

  initForm() {
    this.basicForm = new FormGroup({
      amount_requested: this.amount_requested = new FormControl('', [Validators.required, Validators.min(2000), Validators.max(50000000)]),
      relation: this.relation = new FormControl('', Validators.required),
      campaignerPhone: this.campaignerPhone = new FormControl('', [Validators.required]),
      survey: this.survey = new FormControl('', [Validators.required]),
      qualification: this.qualification = new FormControl('', [Validators.required]),
      occupation: this.occupation = new FormControl('', [Validators.required])
    });
    const userData = this.util.getUserData();
    if (userData?.phone_1) {
      this.askCampaignerPhone = false;
      this.basicForm.removeControl('campaignerPhone');
    }
  }

  /**
   * Get draft details
   */
  getDraft() {
    this.vars.draftObs.subscribe((res) => {
      this.draft = res;
      this.checkForUpdateOnInit();
      // this.vwoPush();
    });
  }

  selectRelation() { }

  basic() {
    if (this.basicForm.valid) {
      this.isLoading = true;
      const payload: any = {
        'amount_requested': this.amount_requested.value,
        'cause_id': 59,
        'parent_cause_id': 20,
        'qualification': this.qualification.value,
        'occupation': this.occupation.value
        // 'g-recaptcha-response': this.captcha.value
      };
      if (this.relation.value !== 'Self') {
        payload.beneficiaryrelation = {
          'info_type': 'beneficiary_relation',
          'entity_type': 'campaign',
          'info_1': this.relation.value
        };
      }
      payload['brandsurvey'] = {
        'info_type': 'brand_survey',
        'entity_type': 'campaign',
        'info_1': this.selectedSurvey,
      };
      this.checkWhichServiceToCall(payload);
    } else {
      this.util.checkValidForm(this.basicForm);
    }
  }

  checkWhichServiceToCall(payload) {
    let draftId = this.actRoute.snapshot.queryParams['did'];
    if (!draftId) {
      const sessDraft = this.util.storage.getFromSession('draft');
      if (sessDraft) {
        draftId = sessDraft?.id;
      }
    }
    !draftId ? this.createCampaign(payload) : this.updateCampaign(payload, draftId);
  }

  getPhoneExtn() {
    this.util.number$.subscribe(res => this.extn = res.extn);
  }

  createCampaign(payload) {
    const date = new Date();
    payload.title = `Draft fundraiser created on ${date.getDate()}/${date.getMonth() + 1}/${date.getFullYear()}`;
    this.campaignService.createCampaign(payload).subscribe((res: any) => {
      const sources = [];
      if (this.campaignService.leaderBoardImage) {
        sources.push(this.campaignService.uploadImageLeaderboard(this.campaignService.leaderBoardImage, res.data.id).subscribe((res: any)=>{
          this.util.openSnackBar('Images of kids will be blurred as per Govt Regulation.', 'success');
        }));
      }
      if (this.campaignService.beneficiaryImage) {
        sources.push(this.campaignService.uploadImageBeneficiary(this.campaignService.beneficiaryImage, res.data.id).subscribe((res: any)=>{
          this.util.openSnackBar('Images of kids will be blurred as per Govt Regulation.', 'success');
        }));
      }
      if (this.campaignService.youTubeVideo) {
        sources.push(this.campaignService.uploadYoutubeVideo(this.campaignService.youTubeVideo, res.data.id));
      }
      if (this.askCampaignerPhone) { // Update campaigner phone number
        const payload2 = {
          'owner': { 'phone_1': this.campaignerPhone.value, 'extension': this.extn }
        };
        sources.push(this.campaignService.updateCampaign(payload2, res.data.id));
      }
      forkJoin(sources).pipe(defaultIfEmpty([])).subscribe(() => {
        this.updateCampaignerPhoneInStorage();
      });
      this.redirectAfterCreateCampaign(res);
    });
  }

  private updateCampaignerPhoneInStorage() {
    if (this.askCampaignerPhone) {
      const phone = {
        extension: this.extn,
        phone_1: this.campaignerPhone.value
      };
      const user = this.util.getUser();
      const userdata = this.util.getUserData();
      user.user.entity = { ...user.user.entity, ...phone };
      this.util.setUser(user);
      this.util.setUserData({ ...userdata, ...phone });
    }
  }

  private redirectAfterCreateCampaign(res: any) {
    this.getDraftById(res.data.creator_entity_details_id, res.data.id, this.type);
    this.gtmPush(res.data);
    this.sendSystemEvent(res.data);
    this.isLoading = false;
  }

  /**Update Campaign
   * @param payload required data for updating campaign
  */
  updateCampaign(payload, id) {
    if (this.askCampaignerPhone) {
      payload['owner'] = { 'phone_1': this.campaignerPhone.value, 'extension': this.extn };
      this.updateCampaignerPhoneInStorage();
    }
    this.campaignService.updateCampaign(payload, id).subscribe((res: any) => {
      // this.captchaRef.reset();
      this.campaignService.getCampaignDraft(id).subscribe(
        (response: any) => {
          this.draft = response.data;
          this.vars.draftObs.next(response.data);
          this.util.addObject(response.data, this.draft);
          this.util.navigateToMedicalForm('advance', this.type, this.draft.id);
          this.isLoading = false;
        }
      );
    });
  }

  /**Check for update */
  checkForUpdateOnInit() {
    const id = this.actRoute.snapshot.queryParams['did'];
    if (id && this.draft) {
      this.patchForm(this.draft);
    }
  }

  /**Patch form */
  patchForm(data) {
    this.basicForm.patchValue({
      'title': data.title,
      'amount_requested': data.amount_requested,
      'qualification': data?.owner?.qualification?.info_1 || '',
      'occupation': data?.owner?.occupation?.info_1 || '',
      survey: data?.brandsurvey?.info_1 || ''
    });
    // this.showCaptcha = false;
    if (data.parent_cause_id === 20) {
      if (data.beneficiaryrelation && data.beneficiaryrelation.info_1) { // && data.beneficiaryrelation.info_1.match('friend|family|pet')
        this.relation.patchValue(data.beneficiaryrelation.info_1);
      } else {
        this.relation.patchValue('Self');
      }
    }
    this.relation.disable();
  }

  getDraftById(entityId, draftId, type) {
    this.campaignService.getCampaignDraft(draftId).subscribe((res: any) => {
      this.draft = res.data;
      this.util.storage.checkFromSession('draft', this.draft);
      this.sendDraftLead();
      this.patchForm(res.data);
      this.vars.draftObs.next(res.data);
      this.util.navigateToMedicalForm('advance', type, this.draft.id);
    });
  }

  /**
   * ALL THE EVENT TRACKING FUNCTIONS
   */
  sendSystemEvent(data) {
    const payload = {
      eventName: 'start_a_campaign_step1_completed',
      event_type: 'campaign',
      page_name: 'Start a Campaign step1',
      info_1: 'type',
      info_2: this.util.getCampaignTypeFromId(data.parent_cause_id),
      info_3: this.util.storage.get('language') || 'English'
    };
    if (data?.id) {
      payload['event_type_id'] = data?.id;
    }
    this.events.systemEventPush(payload);
  }
  /**GTM data push */
  gtmPush(data) {
    const dataPush = {
      event: 'fundraiser_',
      eventCategory: 'fundraiser',
      eventAction: data.parent_cause_name,
      eventLabel: 'step1_completed',
      Campaign_cause_id: data.cause_id,
      Campaign_id: Number(data.draftid),
      Campaign_Type: data.parent_cause_name
    };
    this.events.gtmPush(dataPush);
  }

  openChangePurpose() {
    const dialogRef = this.dialog.open(SacPurposeDialogComponent, {
      // height: '400px',
      // width: '600px',
      panelClass: 'sac-purpose-changer',
      data: {
        frType: 'medical',
        showWarningText: true
      },
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result && result.data && result.data !== 'medical') {
        this.router.navigate(
          [`${this.startAFrUrls['non-medical']}/basic`],
          { queryParams: { type: result.data }, queryParamsHandling: 'merge' }
        );
      }
    });
  }

  onSurveySelect(data) {
    this.selectedSurvey = data;
  }

  submitButton() {
    this.document.getElementById('submitBtn1').click();
  }

  sendDraftLead() {
    const payload: any = {
      type: 'P - Draft campaign (Step 1)',
      subject: 'Draft campaign',
      goal_amount: this.amount_requested.value,
      relation: this.relation.value,
      hear_about_from: this.selectedSurvey,
      parent_cause_id: this.draft?.parent_cause_id,
      cause_id: this.draft?.cause_id,
      cause_name: this.draft?.cause?.info_1,
      CID: this.draft?.id
    };
    if (this.basicForm.get('qualification') && this.basicForm.get('occupation')) {
      payload['qualification'] = this.qualification.value;
      payload['employment_status'] = this.occupation.value;
    }
    this.events.sendLead(payload);
  }

  ngOnDestroy(): void {
    this.subs.forEach(sub => sub.unsubscribe());
  }

}
